export { default as Profile } from './page'


// WEBPACK FOOTER //
// ./src/pages/Profile/index.js